export const DEFAULT_FAVORITES_ANSWERS = {
    adventure: 3,
    art_cultural: 3,
    historical: 3,
    nature: 3,
    religious: 3,
    shopping: 3,
    energy_class: 2,
    price_class: 2,
    sleep_class: 2,
    accommodation: 1,
};
